import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { Ingredient, SpecificIngredient } from "../ingredients/Ingredient";
export const Recipe = Object.freeze({
  /*   name_order: {
    visibleName: "Nombre",
    type: InputTypes.RECIPE_NAME,
  }, */
  recipe_name: {
    visibleName: "Base",
    type: InputTypes.TEXT,
  },
  prep_var: {
    visibleName: "Variación de preparación",
    type: InputTypes.TEXT,
    required: false, //not always on recipes
  },
  /*     glue_excep_ES: {
        visibleName: "Conjunción (Sí: 'De', No: 'Con')",
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.BOOLEAN
        }
    }, */
  suited_meal: {
    visibleName: "Tipo de comida",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  dish_type: {
    visibleName: "Tipo de plato",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  week_day: {
    visibleName: "Día de la semana",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  cook_time: {
    visibleName: "Tiempo de elaboración",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  difficulty: {
    visibleName: "Dificultad",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  season: {
    visibleName: "Época del año",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  /*workout_meal: {
        visibleName: "Pre entrenamiento",
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.BOOLEAN
        }
    },*/
  cook_aux: {
    visibleName: "Robot de cocina",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  portable: {
    visibleName: "Transportable",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  cook_type: {
    visibleName: "Tipo de cocción",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  cuisine: {
    visibleName: "Tipo de cocina",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  max_week_prep: {
    visibleName: "Repeticiones máximas semanales",
    type: InputTypes.NUMBER,
    defaultValue: 1,
    min: 1,
    max: 7,
  },
  //FIXME: Using nutrient_group for the values in legend, instead of rep_group_var
  nutrient_group: {
    visibleName: "Variación de grupos de repetición",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  /* rep_group_var: {
    visibleName: "Variación de grupos de repetición",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  }, */
  veg_ingredients: {
    visibleName: "Vegetales",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes vegetales",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("VEGE"),
      additionalElements: {
        visible_name: {
          visibleName: "Nombre genérico",
          type: InputTypes.TEXT,
        },
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  carb_ingredients: {
    visibleName: "Carbohidratos",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes carbohidratos",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("CARB"),
      additionalElements: {
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  pro_ingredients: {
    visibleName: "Proteicos",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes proteicos",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("PROT"),
      additionalElements: {
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  fat_ingredients: {
    visibleName: "Grasas",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes grasas",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("FATS"),
      additionalElements: {
        visible_name: {
          visibleName: "Nombre genérico",
          type: InputTypes.TEXT,
        },
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  dairy_ingredients: {
    visibleName: "Lácteos",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes lácteos",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("DAIR"),
      additionalElements: {
        visible_name: {
          visibleName: "Nombre genérico",
          type: InputTypes.TEXT,
        },
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  fruit_ingredients: {
    visibleName: "Frutas",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes frutas",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("FRUT"),
      additionalElements: {
        visible_name: {
          visibleName: "Nombre genérico",
          type: InputTypes.TEXT,
        },
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
  seasoning_ingredients: {
    visibleName: "Condimentos",
    type: InputTypes.ARRAY,
    array: {
      name: "ingredient_list",
      visibleName: "Ingredientes condimentos",
      preview: "_id",
      type: InputTypes.COMPOSED,
      composedElements: SpecificIngredient("SEAS"),
      additionalElements: {
        visible_name: {
          visibleName: "Nombre genérico",
          type: InputTypes.TEXT,
        },
        max_weight: {
          visibleName: "Valor máximo de ingredientes",
          type: InputTypes.NUMBER,
        },
        /*         base_preparation: {
          visibleName: "Preparación base",
          type: InputTypes.RICH_TEXT_AREA,
        }, */
      },
    },
  },
});

export const RecipeIngredientLists = Object.freeze({
  veg_ingredients: "VEGE",
  carb_ingredients: "CARB",
  pro_ingredients: "PROT",
  fat_ingredients: "FATS",
  dairy_ingredients: "DAIR",
  fruit_ingredients: "FRUT",
  seasoning_ingredients: "SEAS",
});
